/**
 * Info bar for the stream post component.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { Post, ContentRatings } from '../../../schemas/Post';
import { ShortTag, TagCollection } from '../../../schemas/Tag';

import ReactModal from 'react-modal';

import * as MediaQuery from 'react-responsive';
import * as Icon from 'react-fontawesome';

import './StreamInfo.css';
import { observable } from 'mobx';
import { TagList } from '../../Info/TagList/TagList';

interface StreamInfoProps {
    post: Post<TagCollection<ShortTag>>;
    active: boolean;
    position: number;
}

const statusColours = {
    [ContentRatings.EXPLICIT]: '#e45f5f',
    [ContentRatings.QUESTIONABLE]: '#e4e150',
    [ContentRatings.SAFE]: '#3e9e49',
};

/**
 * Postinfo bar.
 * Scrolls on mobile, and spawns a modal component next to the body for each post.
 * 
 * @class StreamInfo
 * @extends {React.Component<StreamInfoProps>}
 */
@observer
class StreamInfo extends React.Component<StreamInfoProps> {
    @observable tagModalOpened = false;
    
    tagModal = () => (
        <ReactModal 
            shouldCloseOnOverlayClick={false}
            isOpen={this.tagModalOpened}
            contentLabel="Tags"
            style={{
                content: {
                    backgroundColor: '#1c1c1c',
                    color: '#eee', // todo theme
                    zIndex: '99',
                    overflow: 'hidden',
                    height: '98vh',
                    width: '98vw',
                    top: 5,
                    bottom: 5,
                    left: 5,
                    right: 5,
                    display: 'fixed',
                },
                overlay: {
                    zIndex: '99',
                }
            }}
        >
            <span onClick={() => (this.tagModalOpened = false)}>
                <Icon name="times" />
            </span>
            <TagList onActionClick={() => (this.tagModalOpened = false)} active={this.props.position} />
        </ReactModal>
    )

    render() {
        const { post } = this.props;

        return (
            <div className="StreamInfo" style={{ borderColor: statusColours[post.rating] }}>
                <span className="StreamInfo-mobile-tags"> 
                    <MediaQuery maxWidth={1079}>
                        {this.tagModal()}
                        <span onClick={() => (this.tagModalOpened = true)}>
                            <Icon name="tag" />
                        </span>
                    </MediaQuery>
                </span>
                    <span>
                        <Icon name="sort" />
                        <span> {this.props.position + 1} </span>
                    </span>
                    <span className="StreamInfo-Score">
                        <Icon name="arrow-circle-up" />
                        <span className="StreamInfo-Score-Text"> {post.score} </span>
                    </span>
                    <span className="StreamInfo-Fav">
                        <Icon name="heart" />
                        <span className="SteamInfo-Fav-Text"> {post.fav_count} </span>
                    </span>
                    <span className="StreamInfo-Artists">
                        <Icon name="user-circle" />
                        <span className="StreamInfo-Artists-Text"> {post.artist.join(', ')} </span>
                    </span>
            </div>
        );
    }
}

export { StreamInfo };



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Stream/StreamInfo/StreamInfo.tsx